export const initialChantierState = {
  pours: [],
}

export default {
  pours: [],
}
